import moment from 'moment';
import { connect } from 'react-redux';
import { compose, withStateHandlers, withHandlers } from 'recompose';
import DownloadModal from './DownloadModal';
import config from '../../../../config';
import { downloadSummary } from '../actions';
import { activeShopName, getActiveBrandName } from '../../../auth/selectors';
import { isIosBridge } from '../../../iosBridge/helpers';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import withDefaultEndingDate from '../../../main/reports/filters/containers/withDefaultEndingDate';
import withDateToString from '../../../common/hoc/withDateToString';
import { isGmeBrandView } from '../../../main/reports/selectors';

const mapStateToProps = state => ({
  reportName: activeShopName(state) || getActiveBrandName(state),
  timezone: state.auth.timezone,
  exportReportDays: isGmeBrandView(state) ? 1 : config.exportReportDays,
});

const enhance = compose(
  connect(mapStateToProps),
  withOwnerTypeAndId,
  withStateHandlers(
    props => ({
      startDate: moment.tz(props.currentDate, props.timezone).toDate(),
      endDate: moment.tz(props.currentDate, props.timezone).toDate(),
    }),
    {
      onDateChange: () => (startDate, endDate) => ({ startDate, endDate }),
    }
  ),
  withHandlers({
    download: ({ ownerId, ownerType, reportName, startDate, endDate, timezone, close }) => () => {
      const start = moment.tz(startDate, timezone).startOf('day').toJSON();
      const end = moment.tz(endDate, timezone).endOf('day').toJSON();
      return downloadSummary(ownerId, ownerType, reportName, start, end)
        .then(() => close());
    },
    canInstantDownload: ({ startDate, endDate, timezone, exportReportDays }) => () => {
      if (isIosBridge()) {
        return false;
      }

      const start = moment.tz(startDate, timezone).startOf('day');
      const end = moment.tz(endDate, timezone).endOf('day');

      return Math.round(end.diff(start, 'days', true)) <= exportReportDays;
    },
  }),
  withDefaultEndingDate(),
  withDateToString,
);
export default enhance(DownloadModal);
